/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DocumentTemplates/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import React from 'react'
import SuspenseBoundary from 'DesignSystem/SuspenseBoundary/index'
import Templates from './Templates/index'
let Template = React.lazy(() => import('./Template/index'))



/** @type {import('Simple/types.js').View} */
export default function DocumentTemplates({
  children,
  viewPath = "/App/Account/Content/Settings/Content/DocumentTemplates"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Templates'
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<fromFlow.When is={flowValue === 'Templates'}>
<Templates
  viewPath={`${viewPath}/Templates`}
/>
</fromFlow.When>
<SuspenseBoundary
  viewPath={`${viewPath}/SuspenseBoundary`}
>
{childProps => (
<fromFlow.When is={flowValue === 'Template'}>
<Template
{...childProps}
  viewPath={`${viewPath}/Template`}
/>
</fromFlow.When>
)}
</SuspenseBoundary>
{children}
</React.Fragment>)
}